import { requestWithToken } from "../utils/apis";

export const fetchTemplateList = async (page, limit, search = "", sort, order) => {
  try {
    let url = `/api/sectionType/list?page=${page}&limit=${limit}`;

    if (search) url += `&search=${search}`;
    if (sort) url += `&sort=${sort}`;
    if (order) url += `&order=${order}`;

    const response = await requestWithToken("GET", url);
    return response.data;

  } catch (err) {
    return err?.response?.data;
  }
};

export const fetchSectionList = async (page, limit, search = "", sort, order) => {
  try {
    let url = `/api/section/list?page=${page}&limit=${limit}`;

    if (search) url += `&search=${search}`;
    if (sort) url += `&sort=${sort}`;
    if (order) url += `&order=${order}`;
    url += `&is_template=true`;
    const response = await requestWithToken("GET", url);
    return response.data;

  } catch (err) {
    return err?.response?.data;
  }
};

export const StandardFieldList = async () => {
  try {
    let url = `/api/standardFields/list`;
    const response = await requestWithToken("GET", url);
    return response.data;

  } catch (err) {
    return err?.response?.data;
  }
};

export const saveTemplate = async (payload) => {
  try {
    const response = await requestWithToken(
      "POST",
      "/api/sectionType",
      payload
    );
    return response.data; 
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Something went wrong",
    };
  }
};
export const FetchTemplate = async (id) => {
  try {
    const response = await requestWithToken("GET", `/api/sectionType/${id}`);
    return response.data;
  } catch (err) {
    return err?.response?.data;
  }
};
export const UpdateTemplate = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/api/sectionType/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to update template",
    };
  }
};
export const DeleteTemplate = async (id) => {
  try {
    const response = await requestWithToken(
      "DELETE",
      `/api/sectionType/${id}`
    );
    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to Delete template",
    };
  }
};
export const fetchSectionDetail = async (id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/api/section/${id}`
    );
    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to fetch form",
    };
  }
};
export const UpdateSection = async (id, payload) => {
  try {
    const response = await requestWithToken(
      "PUT",
      `/api/section/${id}`,
      payload
    );

    return response.data;
  } catch (err) {
    return err?.response?.data || {
      status: 0,
      message: "Failed to update template",
    };
  }
};
